"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrackingEvents = exports.TrackingEventsContextProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var ui_lib_v2_1 = require("@whispir/ui-lib-v2");
var utils_js_1 = require("@whispir/utils-js");
var TrackingEventsContext = react_1.default.createContext({
    trackImageUploaded: function () { return undefined; },
    trackClickedFromUrl: function () { return undefined; },
    trackClickedFromDevice: function () { return undefined; },
    trackClickedDeleteImage: function () { return undefined; },
    trackClickedDeleteIconLaunchModal: function () { return undefined; },
    trackDeleteModalCancelButtonClicked: function () { return undefined; },
    trackUploadImageClicked: function () { return undefined; },
    trackInsertClicked: function () { return undefined; },
    trackModalClosed: function () { return undefined; },
    trackImageSelected: function () { return undefined; },
});
var TrackingEventsContextProvider = function (props) {
    var _a = (0, react_1.useState)({
        userId: '',
        workspaceId: '',
        workspaceName: '',
    }), sharedTrackingData = _a[0], setSharedTrackingData = _a[1];
    var children = props.children, rest = __rest(props, ["children"]);
    var trackEvent = (0, ui_lib_v2_1.useSegmentContext)().trackEvent;
    (0, react_1.useEffect)(function () {
        var userId = localStorage ? JSON.parse(localStorage.getItem('ajs_user_id') || '""') : '';
        var workspaceId = (0, utils_js_1.getSelectedWorkSpaceId)();
        var workspaceName = (0, utils_js_1.getSelectedWorkSpaceName)();
        setSharedTrackingData({
            userId: userId,
            workspaceId: workspaceId,
            workspaceName: workspaceName,
        });
    }, []);
    var trackImageUploaded = function (data) {
        var userId = sharedTrackingData.userId, workspaceId = sharedTrackingData.workspaceId, workspaceName = sharedTrackingData.workspaceName;
        trackEvent({
            userId: userId,
            event: 'Media Upload: Image uploaded',
            properties: __assign(__assign({}, data), { platform: 'Sparx', workspaceId: workspaceId, workspaceName: workspaceName }),
        });
    };
    var trackClickedFromUrl = function (data) {
        var userId = sharedTrackingData.userId, workspaceId = sharedTrackingData.workspaceId, workspaceName = sharedTrackingData.workspaceName;
        trackEvent({
            userId: userId,
            event: 'Media Upload: Clicked on From URL',
            properties: __assign(__assign({}, data), { platform: 'Sparx', workspaceId: workspaceId, workspaceName: workspaceName }),
        });
    };
    var trackClickedFromDevice = function (data) {
        var userId = sharedTrackingData.userId, workspaceId = sharedTrackingData.workspaceId, workspaceName = sharedTrackingData.workspaceName;
        trackEvent({
            userId: userId,
            event: 'Media Upload: Clicked on From Device',
            properties: __assign(__assign({}, data), { platform: 'Sparx', workspaceId: workspaceId, workspaceName: workspaceName }),
        });
    };
    var trackClickedDeleteImage = function (data) {
        var userId = sharedTrackingData.userId, workspaceId = sharedTrackingData.workspaceId, workspaceName = sharedTrackingData.workspaceName;
        trackEvent({
            userId: userId,
            event: 'Media Upload: Delete image clicked',
            properties: __assign(__assign({}, data), { platform: 'Sparx', workspaceId: workspaceId, workspaceName: workspaceName }),
        });
    };
    var trackDeleteModalCancelButtonClicked = function (data) {
        var userId = sharedTrackingData.userId, workspaceId = sharedTrackingData.workspaceId, workspaceName = sharedTrackingData.workspaceName;
        trackEvent({
            userId: userId,
            event: 'Media Upload: Delete modal Cancel button clicked',
            properties: __assign(__assign({}, data), { platform: 'Sparx', workspaceId: workspaceId, workspaceName: workspaceName }),
        });
    };
    var trackClickedDeleteIconLaunchModal = function (data) {
        var userId = sharedTrackingData.userId, workspaceId = sharedTrackingData.workspaceId, workspaceName = sharedTrackingData.workspaceName;
        trackEvent({
            userId: userId,
            event: 'Media Upload: Uploaded image delete icon clicked',
            properties: __assign(__assign({}, data), { platform: 'Sparx', workspaceId: workspaceId, workspaceName: workspaceName }),
        });
    };
    var trackUploadImageClicked = function (data) {
        var userId = sharedTrackingData.userId, workspaceId = sharedTrackingData.workspaceId, workspaceName = sharedTrackingData.workspaceName;
        trackEvent({
            userId: userId,
            event: 'Media Upload: Upload Image clicked',
            properties: __assign(__assign({}, data), { platform: 'Sparx', workspaceId: workspaceId, workspaceName: workspaceName }),
        });
    };
    var trackInsertClicked = function (data) {
        var userId = sharedTrackingData.userId, workspaceId = sharedTrackingData.workspaceId, workspaceName = sharedTrackingData.workspaceName;
        trackEvent({
            userId: userId,
            event: 'Media Upload: Insert clicked',
            properties: __assign(__assign({}, data), { platform: 'Sparx', workspaceId: workspaceId, workspaceName: workspaceName }),
        });
    };
    var trackModalClosed = function (data) {
        var userId = sharedTrackingData.userId, workspaceId = sharedTrackingData.workspaceId, workspaceName = sharedTrackingData.workspaceName;
        trackEvent({
            userId: userId,
            event: 'Media Upload: Modal closed',
            properties: __assign(__assign({}, data), { platform: 'Sparx', workspaceId: workspaceId, workspaceName: workspaceName }),
        });
    };
    var trackImageSelected = function (data) {
        var userId = sharedTrackingData.userId, workspaceId = sharedTrackingData.workspaceId, workspaceName = sharedTrackingData.workspaceName;
        trackEvent({
            userId: userId,
            event: 'Media Upload: Image selected',
            properties: __assign(__assign({}, data), { platform: 'Sparx', workspaceId: workspaceId, workspaceName: workspaceName }),
        });
    };
    return ((0, jsx_runtime_1.jsx)(ui_lib_v2_1.SegmentContextProvider, { children: (0, jsx_runtime_1.jsx)(TrackingEventsContext.Provider, __assign({ value: __assign({ trackImageUploaded: trackImageUploaded, trackClickedFromUrl: trackClickedFromUrl, trackClickedFromDevice: trackClickedFromDevice, trackClickedDeleteImage: trackClickedDeleteImage, trackDeleteModalCancelButtonClicked: trackDeleteModalCancelButtonClicked, trackUploadImageClicked: trackUploadImageClicked, trackClickedDeleteIconLaunchModal: trackClickedDeleteIconLaunchModal, trackInsertClicked: trackInsertClicked, trackModalClosed: trackModalClosed, trackImageSelected: trackImageSelected }, rest) }, { children: children }), void 0) }, void 0));
};
exports.TrackingEventsContextProvider = TrackingEventsContextProvider;
var useTrackingEvents = function () {
    var context = react_1.default.useContext(TrackingEventsContext);
    return context;
};
exports.useTrackingEvents = useTrackingEvents;
